import "../../assets/css/authUser/authUser.css"

import Axios from "axios";
import Swal from "sweetalert2"
import { useState, useRef, useEffect } from "react"
import { useNavigate } from "react-router-dom";

import { useAuth } from "../../context/auth-context";
import { APP_ROUTES, sweetAlertLoading } from "../../utils/globalUtils";

const TEASER_VERIFICATION_URI = process.env.REACT_APP_VERIFICATION

export default function AuthUser() {
    const { activeVerificationCode, updateUser } = useAuth()
    const navigate = useNavigate()

    const [code, setCode] = useState({
        digit1: "",
        digit2: "",
        digit3: "",
        digit4: "",
        digit5: "",
        digit6: "",
    })

    const inputRefs = {
        digit1: useRef(null),
        digit2: useRef(null),
        digit3: useRef(null),
        digit4: useRef(null),
        digit5: useRef(null),
        digit6: useRef(null),
    };

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            // Cancel the event as returning a non-void value will prompt a confirmation dialog
            event.preventDefault();
            // Chrome requires returnValue to be set
            event.returnValue = '';

            // Perform any additional cleanup or logic you need before the page unloads
            // For example, you might want to save data or show a confirmation message
            // console.log("User is trying to leave the page");
        };

        // Add the event listener when the component mounts
        window.addEventListener('beforeunload', handleBeforeUnload);

        // Remove the event listener when the component unmounts
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    useEffect(() => {
        if (code.digit6 === "") return

        sweetAlertLoading()

        const codeToSend = +`${code.digit1}${code.digit2}${code.digit3}${code.digit4}${code.digit5}${code.digit6}`
        const dataToSend = {
            userId: activeVerificationCode,
            codeToVerify: codeToSend
        }

        activeVerificationCode && Axios.post(TEASER_VERIFICATION_URI, dataToSend).then(res => {
            Swal.fire({
                icon: res.status === 200 ? 'success' : "error",
                text: res.data.message,
                showConfirmButton: false,
                timer: 1500,
                timerProgressBar: true,
                didDestroy: () => {
                    if (res.status === 203) return

                    updateUser(res.data.user)
                    navigate(APP_ROUTES.report)
                }
            })

            if (res.status === 203) {
                setCode({
                    digit1: "",
                    digit2: "",
                    digit3: "",
                    digit4: "",
                    digit5: "",
                    digit6: "",
                })
            }
        }).catch(err => {
            Swal.fire({
                icon: "error",
                text: err?.response?.data?.message || "Error verifying code",
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
                didDestroy: () => {
                    navigate(APP_ROUTES.login)
                }
            })
            console.log(err?.response?.data?.message || "Error verifying code")
        })
    }, [code])

    function handleOnFocus(property) {
        if (code[property] !== "") return

        if (inputRefs.digit1.current.value === "") {
            inputRefs.digit1.current.focus()

            return
        }
        if (inputRefs.digit2.current.value === "") {
            inputRefs.digit2.current.focus()

            return
        }
        if (inputRefs.digit3.current.value === "") {
            inputRefs.digit3.current.focus()

            return
        }
        if (inputRefs.digit4.current.value === "") {
            inputRefs.digit4.current.focus()

            return
        }
        if (inputRefs.digit5.current.value === "") {
            inputRefs.digit5.current.focus()

            return
        }
        if (inputRefs.digit6.current.value === "") {
            inputRefs.digit6.current.focus()

            return
        }
    }

    function handleCode(value, property) {
        if (!/^\d$/.test(value) && value !== "" && value.length !== 6) return

        if (value.length === 6) {
            const values = value.split("")

            setCode({
                digit1: values[0],
                digit2: values[1],
                digit3: values[2],
                digit4: values[3],
                digit5: values[4],
                digit6: values[5],
            })


            inputRefs.digit1.current.blur()

            return
        }

        const valueToSave = value === "" ? "" : code[property] !== "" ? value?.split("")[1] : value?.split("")[0]

        setCode(prev => {
            return {
                ...prev,
                [property]: valueToSave
            }
        })


        switch (property) {
            case 'digit1':
                value && inputRefs.digit2.current.focus();
                break;
            case 'digit2':
                !value && inputRefs.digit1.current.focus();
                value && inputRefs.digit3.current.focus();
                break;
            case 'digit3':
                !value && inputRefs.digit2.current.focus();
                value && inputRefs.digit4.current.focus();
                break;
            case 'digit4':
                !value && inputRefs.digit3.current.focus();
                value && inputRefs.digit5.current.focus();
                break;
            case 'digit5':
                !value && inputRefs.digit4.current.focus();
                value && inputRefs.digit6.current.focus();
                break;
            case 'digit6':
                !value && inputRefs.digit5.current.focus();
                break;
            default:
                // No auto focus after digit6
                break;
        }
    }

    return (
        <section className="authUserSection">
            <h3>Verification code</h3>

            <div className="inputsSection">
                <input
                    className="inputCode"
                    ref={inputRefs.digit1}
                    name="digit1"
                    type="text"
                    value={code.digit1}
                    onFocus={() => handleOnFocus("digit1")}
                    onChange={(e) => handleCode(e.target.value, "digit1")}
                />
                <input
                    className="inputCode"
                    ref={inputRefs.digit2}
                    name="digit2"
                    type="text"
                    value={code.digit2}
                    onFocus={() => handleOnFocus("digit2")}
                    onChange={(e) => handleCode(e.target.value, "digit2")}
                />
                <input
                    className="inputCode"
                    ref={inputRefs.digit3}
                    name="digit3"
                    type="text"
                    value={code.digit3}
                    onFocus={() => handleOnFocus("digit3")}
                    onChange={(e) => handleCode(e.target.value, "digit3")}
                />
                <input
                    className="inputCode"
                    ref={inputRefs.digit4}
                    name="digit4"
                    type="text"
                    value={code.digit4}
                    onFocus={() => handleOnFocus("digit4")}
                    onChange={(e) => handleCode(e.target.value, "digit4")}
                />
                <input
                    className="inputCode"
                    ref={inputRefs.digit5}
                    name="digit5"
                    type="text"
                    value={code.digit5}
                    onFocus={() => handleOnFocus("digit5")}
                    onChange={(e) => handleCode(e.target.value, "digit5")}
                />
                <input
                    className="inputCode"
                    ref={inputRefs.digit6}
                    name="digit6"
                    type="text"
                    value={code.digit6}
                    onFocus={() => handleOnFocus("digit6")}
                    onChange={(e) => handleCode(e.target.value, "digit6")}
                />
            </div>
        </section>
    )
}
